import db, { type NtfyDatabase } from "./db";
import type { ThemeMode } from "./types";

export const THEME = {
  DARK: "dark",
  LIGHT: "light",
  SYSTEM: "system",
} as const;

class Prefs {
  db: NtfyDatabase;

  constructor(dbImpl: NtfyDatabase) {
    this.db = dbImpl;
  }

  async setSound(sound: string) {
    this.db.prefs.put({ key: "sound", value: sound.toString() });
  }

  async sound(): Promise<string> {
    const sound = await this.db.prefs.get("sound");
    // The "sound" pref is always stored as a string (see setSound / sync).
    return sound ? (sound.value as string) : "ding";
  }

  async setDeleteAfter(deleteAfter: number | string) {
    await this.db.prefs.put({ key: "deleteAfter", value: deleteAfter.toString() });
  }

  async deleteAfter() {
    const deleteAfter = await this.db.prefs.get("deleteAfter");
    return deleteAfter ? Number(deleteAfter.value) : 604800; // Default is one week
  }

  async theme(): Promise<ThemeMode> {
    const theme = await this.db.prefs.get("theme");
    return (theme?.value as ThemeMode) ?? THEME.SYSTEM;
  }

  async setTheme(mode: ThemeMode) {
    await this.db.prefs.put({ key: "theme", value: mode });
  }
}

const prefs = new Prefs(db());
export default prefs;
